import React from "react";
interface IconProps {
	color?: string;
}
export const ChevronIcon = ({ color }: IconProps) => {
	return (
		<svg viewBox="0 0 24 24" width={18} height={18}>
			<path
				d="M9 6l6 6-6 6"
				fill="none"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
